export const TOOLS_TYPE = 'tools'
export const FEATURES_TYPE = 'features'

export const TOOLS_SECTION = '_libraries'
export const FEATURES_SECTION = '_features'

export const ITEMS_ID = '_items'
export const CARDINALITIES_ID = '_cardinalities'

export const TOOLS_OPTIONS = [
    'would_use',
    'would_not_use',
    'interested',
    'not_interested',
    'never_heard'
]

export const FEATURES_OPTIONS = ['never_heard', 'heard', 'used']

export const FEATURES_OPTIONS2 = [
    'never_heard',
    'interested',
    'not_interested',
    'used_positive',
    'used_negative'
]

export const OVERALL = 'overall'

export const NO_ANSWER = 'no_answer'

export const NO_MATCH = 'no_match'

export const OTHER_ANSWERS = 'other_answers'

export const CUTOFF_ANSWERS = 'cutoff_answers'

export const OVERLIMIT_ANSWERS = 'overlimit_answers'

export const NOT_APPLICABLE = 'na'

export const DEFAULT = 'default'

export const DISCARDED_ANSWER = 'discarded_answer'

export const UNSUPPORTED_LANGUAGE = 'unsupported_language' // e.g not english

export const CUSTOM_NORMALIZATION = 'custom_normalization'

export const AI_NORMALIZATION = 'ai_normalization'

export const IMPORTED_NORMALIZATION = 'imported_normalization'

export const INSUFFICIENT_DATA = 'insufficient_data'

export const PERCENTAGE_SURVEY = 'percentageSurvey'
export const PERCENTAGE_QUESTION = 'percentageQuestion'
export const PERCENTAGE_BUCKET = 'percentageBucket'
export const COUNT = 'count'

export const MAIN_UNITS = [PERCENTAGE_SURVEY, PERCENTAGE_QUESTION, COUNT]

export const PARTIAL_WORD_INDICATOR = '[p]'

export const ENTIRE_CONTENTS_INDICATOR = '[e]'

export const WHOLE_WORD_INDICATOR = '[w]'

export const LIST_INDICATOR = '[l]'

export const NEUTRAL_SENTIMENT = 'neutral'
export const POSITIVE_SENTIMENT = 'positive'
export const NEGATIVE_SENTIMENT = 'negative'

export const SENTIMENT_FACET = '_sentiment'

export const CATCHALL_PREFIX = 'catchall_'

export const PAST_PARTICIPATIONS = 'past_participations'
export const FUTURE_PARTICIPATIONS = 'future_participations'
